<!--
  - 代码运行首页
-->

<template>
  <div class="build_index">
    <editor/>
  </div>
</template>


<script>
import editor from './widgets/editor'
export default{
  name: 'build_index',
  data(){
    return {
    };
  },
  components:{
    editor,
  },
  created(){
  }
}
</script>

<style scoped lang="less">
.build_index{
  flex: 1 1 auto;
}
</style>
